export interface DialogHandle {
  readonly open: boolean;
  showModal(): void;
  close(): void;
}

export function syncDialogOpenState(
  dialog: DialogHandle,
  shouldBeOpen: boolean,
) {
  if (shouldBeOpen && !dialog.open) {
    dialog.showModal();
    return "opened" as const;
  }

  if (!shouldBeOpen && dialog.open) {
    dialog.close();
    return "closed" as const;
  }

  return "unchanged" as const;
}
